

var Model = require("../types/Model.js");
var par = require("par");
var window = require("global");
var document = window.document;
// eslint-disable-next-line node/no-missing-require
var AppState = require("react-native").AppState;

module.exports = Model({
	name: "screenfocus",
	init: init,
	uninit: uninit,

	_currentState: null,
	_on_pause: null,
	_on_resume: null,
	_changeListener: null,
});

function init() {
	this._on_pause = par(on_pause, this);
	this._on_resume = par(on_resume, this);

	if(document){
		document.addEventListener("pause", this._on_pause, false);
		document.addEventListener("resume", this._on_resume, false);
		this.push(true);
	}

	if(AppState) {
		this._changeListener = AppState.addEventListener("change", handleAppStateChange.bind(this));
		this._currentState = AppState.currentState;
		if(this._currentState === "active")
			this.push(true);
		else this.push(false);
	}
}

function uninit() {
	if(document) {
		document.removeEventListener("pause", this._on_pause, false);
		document.removeEventListener("resume", this._on_resume, false);
	}

	this._on_pause = null;
	this._on_resume = null;

	if(this._changeListener) {
		this._changeListener.remove();
	}
}

function on_pause(model) {
	model.push(false);
}

function on_resume(model) {
	model.push(true);
}

function handleAppStateChange(newAppState) {
	if(newAppState === "active")
		this.push(true);
	else this.push(false);
}
